export const EM_SALES_REPORTS_SLICE_NAME = '@@emSalesReports';
